import React from "react";

interface LogCodeProps {
  code: string;
  className?: string;
}

const LogCode: React.FC<LogCodeProps> = ({ code, className = "" }) => {
  const segments = code.split(".");

  return (
    <span className={`font-mono break-words ${className}`}>
      {segments.map((segment, index) => (
        <React.Fragment key={index}>
          {segment}
          {index < segments.length - 1 && (
            <>
              .<wbr />
            </>
          )}
        </React.Fragment>
      ))}
    </span>
  );
};

export default LogCode;
